import { getCurrentInstance } from "vue";
import popupModal from "@/components/modals/popup.vue";
const Confirm = {
    install(app, options = {}) {
        app.provide("$popup", {
            open: (title, message) => {
                const baseOpt = {
                    parent: getCurrentInstance(),
                    component: popupModal,
                    trapFocus: true
                };
                app.config.globalProperties.$oruga.modal.open({
                    ...baseOpt,
                    props: {
                        title: title,
                        message: message
                    }
                });
            }
        });
    }
};
export default Confirm;
